(function() {
  'use strict';

  angular.module('app.maps')
    .directive('publicMap', publicMap);

  /** @ngInject */
  function publicMap($templateCache, esriRegistry, esriLoader, $q, $window, SidePanelLayers, Loader, maps, $timeout, hoverTip, Reports, appConfig, $uibModal) {
    return {
      restrict: 'E',
      controller: 'PublicMapCtrl',
      controllerAs: 'vm',
      bindToController: true, // because the scope is isolated
      template: $templateCache.get('modules/maps/publicMap/publicMap.html'),
      link: function(scope, element, attrs) {
        let mapDeferred = $q.defer();
        // enable the loader initally
        Loader.enable();

        attrs.$observe('registerAs', function(value) {
          value = 'publicMap';
          let deregister = esriRegistry._register(value, mapDeferred.promise);
          // remove this from the registry when the scope is destroyed
          scope.$on('$destroy', deregister);
        });

        esriLoader.require([
          'esri/config',
          'esri/arcgis/utils',
          'esri/map',
          'esri/request',
          'esri/dijit/BasemapGallery',
          'esri/dijit/Search',
          'esri/tasks/locator',
          'esri/dijit/HomeButton',
          'esri/dijit/LocateButton',
          'esri/tasks/query',
          'esri/tasks/QueryTask',
          'esri/tasks/PrintTask',
          'esri/tasks/PrintParameters',
          'esri/tasks/PrintTemplate',
          'esri/symbols/SimpleFillSymbol',
          'esri/symbols/SimpleLineSymbol',
          'esri/Color',

          'dojo/i18n!esri/nls/jsapi',
          'dojo/on',
          'dojo/dom',
          'dojo/fx',
          'dojo/fx/Toggler',
          'dojo/parser',
          'dojo/query',
          'dojo/dom-construct',
          'dojo/NodeList-traverse',
          'dijit/layout/ContentPane',
          'dijit/TitlePane',
          'dojo/domReady!'
        ], function(
          esriConfig,
          arcgisUtils,
          Map,
          esriRequest,
          BasemapGallery,
          Search,
          Locator,
          HomeButton,
          LocateButton,
          Query,
          QueryTask,
          PrintTask,
          PrintParameters,
          PrintTemplate,
          SimpleFillSymbol,
          SimpleLineSymbol,
          Color,

          i18n,
          on,
          dom,
          corefx,
          Toggler,
          parser,
          query,
          domConstruct
        ) {

          parser.parse();

          // initialize the map
          // map creation options
          let mapOptions = {
            mapOptions: {
              lods: [{
                  level: 10,
                  resolution: 152.874056570411,
                  scale: 577790.554289
                },
                {
                  level: 11,
                  resolution: 76.4370282850732,
                  scale: 288895.277144
                },
                {
                  level: 12,
                  resolution: 38.2185141425366,
                  scale: 144447.638572
                },
                {
                  level: 13,
                  resolution: 19.1092570712683,
                  scale: 72223.819286
                },
                {
                  level: 14,
                  resolution: 9.55462853563415,
                  scale: 36111.909643
                },
                {
                  level: 15,
                  resolution: 4.77731426794937,
                  scale: 18055.954822
                },
                {
                  level: 16,
                  resolution: 2.38865713397468,
                  scale: 9027.977411
                },
                {
                  level: 17,
                  resolution: 1.19432856685505,
                  scale: 4513.988705
                },
                {
                  level: 18,
                  resolution: 0.597164283559817,
                  scale: 2256.994353
                },
                {
                  level: 19,
                  resolution: 0.298582141647617,
                  scale: 1128.497176
                }
              ]
            }
          };
          let config = appConfig.getConfig();
          let deferred = arcgisUtils.createMap(config.publicWebMapId, 'publicMap', mapOptions); // , mapOptions
          let keydownLength = 0;
          deferred.then(function(response) {
              // hide the jira feedback button from the public side
              try {
                document.getElementById('atlwdg-trigger').style.display = 'none';
              } catch (err) {
                console.warn('We could not estabish a JIRA link due to an error: ', err);
              }
              // add cors servers
              esriConfig.defaults.io.corsEnabledServers.push('chef.northpointgis.com');
              esriConfig.defaults.io.corsEnabledServers.push('gis.crowwing.us');

              // assign the map response to the esri angular map
              scope.mapVar = response.map;
              let map = scope.mapVar;
              mapDeferred.resolve(map);

              // set the map factory map Object
              maps.setMap(response.map);

              // set the filter layer from the map
              let mapLayers = response.itemInfo.itemData.operationalLayers;

              // send the layer list to the sidepanelLayers factory for setup
              SidePanelLayers.setLayers(response.itemInfo.itemData.operationalLayers, map.getScale());

              let parcelLayer,
                otcPtsLayer,
                auctionPtsLayer,
                tractsLayer,
                auctionPolyLayer,
                sources = [],
                auctionDefaultFilter,
                otcDefaultFilter,
                otcPolyLayer,
                parcelDefaultFilter;

              for (let layer of mapLayers) {
                // setup the over the counter points layer
                if (layer.title === config.otcPts) {
                  otcPtsLayer = layer.layerObject;
                  // set default filter from ago
                  otcDefaultFilter = layer.layerDefinition.definitionExpression;
                }
                // setup the auction points layer
                if (layer.title === config.auctionPts) {
                  // console.log('intial query auction pts = ', layer.layerDefinition.definitionExpression);
                  auctionPtsLayer = layer.layerObject;
                  let today = new Date();
                  auctionPtsLayer.setDefinitionExpression('Last_LS_date >= date \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\' AND ProposedSaleType = \'Auction\'');
                  // set default filter from ago
                  // auctionDefaultFilter = layer.layerDefinition.definitionExpression;
                  auctionDefaultFilter = 'Last_LS_date >= date \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\' AND ProposedSaleType = \'Auction\'';
                }
                // setup the auction polygon layer
                if (layer.title === config.auctionPoly) {
                  // console.log('auction tracts polygons = ', layer.layerObject);
                  auctionPolyLayer = layer.layerObject;
                  let today = new Date();
                  layer.layerObject.setDefinitionExpression('Last_LS_date >= date \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\' AND ProposedSaleType = \'Auction\'');
                  // set default filter from ago
                  // auctionDefaultFilter = layer.layerDefinition.definitionExpression;
                }
                // setup the otc polygon layer
                if (layer.title === config.otcPoly) {
                  // console.log('auction tracts polygons = ', layer.layerObject);
                  otcPolyLayer = layer.layerObject;
                }
                // setup the parcel boundaries display layer
                if (layer.title === config.parcelTitle) {
                  parcelLayer = layer.layerObject;
                  // set default filter from ago
                  parcelDefaultFilter = layer.layerDefinition.definitionExpression;
                  // add the layer to the search bar
                  // sources.push({
                  //   featureLayer: parcelLayer,
                  //   searchFields: ['PIN'],
                  //   exactMatch: false,
                  //   outFields: ['*'],
                  //   name: layer.title,
                  //   placeholder: layer.title,
                  //   maxResults: 6,
                  //   maxSuggestions: 6,
                  //   enableSuggestions: true,
                  //   minCharacters: 0,
                  //   enableHighlight: false
                  // });
                }
                // setup the tracts layer
                if (layer.title === config.searchingTracts) {
                  tractsLayer = layer.layerObject;
                  // symbol for highlighting features from the search results
                  let sfs = new SimpleFillSymbol(SimpleFillSymbol.STYLE_NULL,
                    new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID,
                      new Color([255, 255, 0]), 6));
                  // add the tracts layer to the search bar
                  sources.push({
                    featureLayer: tractsLayer,
                    searchFields: ['Tract', 'PIN'],
                    suggestionTemplate: '${Tract} : ${PIN}',
                    exactMatch: false,
                    outFields: ['*'],
                    name: layer.title,
                    placeholder: layer.title,
                    maxResults: 6,
                    maxSuggestions: 6,
                    enableSuggestions: true,
                    minCharacters: 0,
                    enableHighlight: true,
                    highlightSymbol: sfs
                  });
                }
              }

              // set the map filter layers
              // maps.setPublicFilterLayers(tractsLayer, auctionPtsLayer, otcPtsLayer, parcelLayer);
              maps.setPublicFilterLayers(auctionPtsLayer, otcPtsLayer, auctionPolyLayer, otcPolyLayer, parcelLayer, tractsLayer);
              maps.setPublicDefaultMapFilter(auctionDefaultFilter, otcDefaultFilter, parcelDefaultFilter);
              // set additional default map layer queries not coming from ArcGIS Online
              maps.setInitialQuery();
              // add the home button to the map
              let home = new HomeButton({
                map: map
              }, 'HomeButton');
              home.startup();

              // set the search widget sources to limit the results to the update-start
              sources.push({
                locator: new Locator('//geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer'),
                singleLineFieldName: 'SingleLine',
                outFields: ['Addr_type'],
                name: i18n.widgets.Search.main.esriLocatorName,
                localSearchOptions: {
                  minScale: 300000,
                  distance: 50000
                },
                placeholder: i18n.widgets.Search.main.placeholder,
                countryCode: 'US',
                searchExtent: map.extent,
                enableInfoWindow: false
              });

              // initialize the search widget
              let s = new Search({
                map: map,
                enableButtonMode: true,
                expanded: false,
                sources: sources,
                activeSourceIndex: 'all',
                showInfoWindowOnSelect: false
              }, 'search');

              s.startup();

              // initialize the locate button
              let locateButton = new LocateButton({
                map: map,
                scale: 15000,
                useTracking: true,
                centerAt: true,
                setScale: false,
                geolocationOptions: {
                  maximumAge: 0,
                  timeout: 2000
                }
              }, 'LocateButton');
              locateButton.clearOnTrackingStop = true;
              locateButton.startup();

              // Basemap button
              let toggler;
              let basemapGallery = new BasemapGallery({
                showArcGISBasemaps: true,
                map: map
              }, 'basemapGallery');

              basemapGallery.startup();

              function basemapToggle() {
                toggler = new Toggler({
                  node: 'basemaptoggle',
                  showFunc: corefx.wipeIn,
                  // showDuration: 1000,
                  // hideDuration: 1000,
                  hideFunc: corefx.wipeOut
                });
              }
              dojo.addOnLoad(basemapToggle);

              on(dom.byId('basemapbutton'), 'click', function() {
                toggler[(dojo.style('basemaptoggle', 'display') === 'none') ? 'show' : 'hide']();
              });

              // TESTING the map scale
              // on(map, 'extent-change', function(evt){
              //   console.log(map.getScale(), evt.lod);
              // });

              // setup hover tooltip
              hoverTip.setupHover();

              // setup hover over feature tooltip
              on(otcPtsLayer, 'mouse-over', function(event) {
                hoverTip.setHoverContent(event);
              });

              on(otcPtsLayer, 'mouse-out', function() {
                hoverTip.closeHover();
              });

              on(auctionPtsLayer, 'mouse-over', function(event) {
                hoverTip.setHoverContent(event);
              });

              on(auctionPtsLayer, 'mouse-out', function() {
                hoverTip.closeHover();
              });

              // setup map click event
              let popupFeatures,
                nextEvent,
                prevEvent,
                directionsFeature;
              let id = 0;

              // setup map click event
              on(map.infoWindow, 'show', function(event) {
                console.log('feature ', event.target.features);
                popupFeatures = event.target.features;
                id = 0;

                // previous feature click event
                if (prevEvent == null) {
                  prevEvent = on(query('.prev')[0], 'click', function() {
                    id = id - 1;
                    domConstruct.destroy('createBrochure');
                    constructBrochureLink(popupFeatures[id]);
                    directionsFeature = popupFeatures[id];
                  });
                }
                if (nextEvent == null) {
                  nextEvent = on(query('.next')[0], 'click', function() {
                    id = id + 1;
                    domConstruct.destroy('createBrochure');
                    constructBrochureLink(popupFeatures[id]);
                    directionsFeature = popupFeatures[id];
                  });
                }
                // FIXME: doesn't work when cycling through multiple results
                queryAttachments(popupFeatures[0].attributes.OBJECTID, tractsLayer).then(function(results) {
                  let attachments = results;
                  if (attachments.length > 0) {
                    domConstruct.place("<div id='photos'></div>", query('.mainSection')[0], "after"); //jshint ignore:line
                    for (let i = 0; i < attachments.length; i++) {
                      domConstruct.place("<img class='popup-pic' src='" + attachments[i].url + "' alt='No Image Available'/>", "photos");
                    }
                  }
                });

                let firstFeature = event.target.features[0];
                directionsFeature = firstFeature;
                // let structurePresent = firstFeature.attributes.StructurePresent;

                // if (structurePresent === 'No') {
                //   $timeout(function() {
                //     document.getElementsByClassName('attrTable')[0].deleteRow(1);
                //   }, 550);
                // }
                // place the directions button at the bottom of the popup
                domConstruct.place("<a id='getDirections' title='Directions' class='action' href='#' style='float:right;'><span class='esri-icon-directions'></span><span>Directions</span></a>", query('.actionList')[0]); // jshint ignore:line
                // construct the brochure link for the selected tract
                constructBrochureLink(popupFeatures[0]);
                // internal function for getting directions to the selected feature
                document.getElementById('getDirections').onclick = function() {
                  let featureAttributes = directionsFeature.attributes;
                  // If it's an iPhone
                  if ((navigator.platform.indexOf('iPhone') !== -1) || (navigator.platform.indexOf('iPod') !== -1)) {
                    // let protocol = '';
                    let ver = iOSversion() || [0];
                    if (ver[0] >= 6) {
                      // protocol = 'maps://';
                      window.location = featureAttributes.mapsIos;
                    } else {
                      // protocol = 'http://';
                      window.location = featureAttributes.httpIos;
                    }
                    // window.location = protocol + 'maps.apple.com/maps?daddr=' + lat + ',' + lng + '&amp;ll=';
                  } else {
                    window.open(featureAttributes.httpOther);
                    // window.open('http://maps.google.com?daddr=' + lat + ',' + lng + '&amp;ll=');
                  }
                };
              });

              // setup map click event
              on(map.infoWindow, 'hide', function() {
                domConstruct.destroy('getDirections');
                domConstruct.destroy('createBrochure');
              });

              // iOS helper
              function iOSversion() {
                if (/iP(hone|od|ad)/.test(navigator.platform)) {
                  // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
                  var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                  return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
                }
              }

              // add the loading icon to the map
              on(map, 'update-start', function() {
                Loader.enable();
              });

              on(map, 'update-end', function() {
                Loader.disable();
              });

              on(map, 'zoom-end', function() {
                SidePanelLayers.updateVisibility();
              });


              function queryAttachments(objectid, featureLayer) {
                let d = $q.defer();
                featureLayer.queryAttachmentInfos(objectid, function(results) {
                  d.resolve(results);
                });
                return d.promise;
              }

              // create the brochure link
              function constructBrochureLink(tract) {
                domConstruct.place("<a id='createBrochure' title='Print Brochure' class='action' href='#' style='float:right;'><span class='esri-icon-printer'></span><span id='printText'> Print Brochure</span></a>", query('.actionList')[0]); // jshint ignore:line
                document.getElementById('createBrochure').onclick = function() {

                  let modalInstance = $uibModal.open({
                    animation: true,
                    template: $templateCache.get('modules/core/modals/popupwarning.tpl.html'),
                    controller: 'PopupDialogCtrl',
                    size: 'sm',
                    resolve: {
                      message: function() {
                        return 'Popup blockers must be disabled before printing.';
                      },
                      showWarning: function() {
                        return true;
                      }
                    }
                  });

                  modalInstance.result.then(function() {
                      // hide the parcel layer for printing
                      parcelLayer.hide();
                      // set the button to busy while printing
                      let printingElem = angular.element(document.querySelector('#printText'));
                      let printAnchor = angular.element(document.querySelector('#createBrochure'));
                      printAnchor.addClass('disabled');
                      printingElem.html(' Printing...');
                      // add the zoom end handler to ensure the map is done zooming before printing
                      let zoomEndHandler = on(map, 'extent-change', function() {
                        zoomEndHandler.remove();
                        // set definition query so only the selected tract shows on brochure map
                        let defQuery = 'Tract = \'' + tract.attributes.Tract + '\'';
                        tractsLayer.setDefinitionExpression(defQuery);

                        // query the attachments to get the picture for the brochure
                        let query = new Query();
                        query.where = 'Tract = \'' + tract.attributes.Tract + '\'';

                        tractsLayer.queryIds(query, function(ids) {
                          tractsLayer.queryAttachmentInfos(ids[0], function(results) {
                            let picUrl = 'no-image-available.jpg';
                            if (results.length > 0) {
                              picUrl = results[0].url;
                            }
                            // console.log('picture URL ', picUrl);
                            // prepare the map for printing
                            let url = config.printService;
                            let printTask = new PrintTask(url);
                            let params = new PrintParameters();
                            params.map = map;
                            // setup the print template
                            let template = new PrintTemplate();
                            template.exportOptions = {
                              width: 800,
                              height: 800,
                              dpi: 300
                            };
                            template.format = 'PNG8';
                            template.layout = 'MAP_ONLY';
                            template.showAttribution = false;
                            template.preserveScale = false;
                            params.template = template;

                            // brochure backgroud images
                            let bkImage = 'Crow_Wing_Flyer_Layout.png';

                            // submit the print job
                            printTask.execute(params, function(result) {
                              Reports.brochure(tract.attributes, picUrl, result.url, bkImage).then(function(result) {
                                // reset the printing button
                                let printingElem = angular.element(document.querySelector('#printText'));
                                printingElem.html(' Print Brochure');
                                printAnchor.removeClass('disabled');
                                parcelLayer.show();
                                $window.open(result);
                                // show all tracts again
                                tractsLayer.setDefinitionExpression('');
                              });
                            }, function(err) {
                              // reset the printing button and remove definition query
                              let printingElem = angular.element(document.querySelector('#printText'));
                              printingElem.html(' Print Brochure');
                              printAnchor.removeClass('disabled');
                              tractsLayer.setDefinitionExpression('');
                              console.log('PRINTING ERROR: ', err);
                            });
                          });
                        });
                      });

                      // zoom to the selected tract
                      let mapExtent = tract.geometry.getExtent();
                      map.setExtent(mapExtent, true);
                  });
                };
              }

            },
            function(error) {
              console.error('Error: ', error.code, ' Message: ', error.message);
              deferred.cancel();
            });
        });
      }
    };
  }
})();
